import { render } from "./MailRender.vue?vue&type=template&id=40d9358c&scoped=true"
import script from "./MailRender.vue?vue&type=script&lang=js"
export * from "./MailRender.vue?vue&type=script&lang=js"

import "./MailRender.vue?vue&type=style&index=0&id=40d9358c&scoped=true&lang=scss"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d9358c"]])

export default __exports__